
/**
 * Contact Form
 *
 * Simple contact form block for collecting messages from visitors.
 *
 * @TODO Add email subject setting.
 * @TODO Add redirect setting.
 */
( function( blocks, i18n, element, components ) {
	var el = element.createElement;
	var __ = i18n.__;
    var Editable = blocks.Editable;
	var Dashicon = components.Dashicon;
	var ExternalLink = components.ExternalLink;
	var InspectorControls = blocks.InspectorControls;
	var BaseControl = blocks.InspectorControls.BaseControl;
	var TextControl = blocks.InspectorControls.TextControl;
	var TextControl = blocks.InspectorControls.TextControl;
	var ToggleControl = blocks.InspectorControls.ToggleControl;
	var BlockDescription = blocks.BlockDescription;
	var BlockControls = blocks.BlockControls;
	var AlignmentToolbar = blocks.AlignmentToolbar;

	function contactForm( props ) {
		var focus = props.focus;
		var showRequired = props.attributes.showRequired;

		var requiredNotice = el( 'small', {},
								'Fields marked with an ',
								el( 'span', { style: { color: 'red' } }, '*' ),
								' are required.'
							);

		var nameLabel = props.attributes.nameLabel;
		function onChangeNameLabel( newLabel ){
			if( Array.isArray( newLabel ) ) newLabel = newLabel[0];
			props.setAttributes( { nameLabel: newLabel } );
		}

		var emailLabel = props.attributes.emailLabel;
		function onChangeEmailLabel( newLabel ){
			if( Array.isArray( newLabel ) ) newLabel = newLabel[0];
			props.setAttributes( { emailLabel: newLabel } );
		}

		var messageLabel = props.attributes.messageLabel;
		function onChangeMessageLabel( newLabel ){
			if( Array.isArray( newLabel ) ) newLabel = newLabel[0];
			props.setAttributes( { messageLabel: newLabel } );
		}

		var submitLabel = props.attributes.submitLabel;
		function onChangeSubmitLabel( newLabel ){
			if( Array.isArray( newLabel ) ) newLabel = newLabel[0];
			props.setAttributes( { submitLabel: newLabel } );
		}

		return el( 'form',
			{
				className: 'form-blocks--form form-blocks--align-' + props.attributes.align,
				action: '',
				method: 'POST'
			},

			!! showRequired && requiredNotice,

			// FIELD: Full Name
			el( 'div', { className: 'form-blocks--field-wrap' },
				el( 'label', { style: { display: 'inline-block' } },
					el( Editable, { value: nameLabel, onChange: onChangeNameLabel }	)
				),
				!! showRequired && el( 'span', { style: { color: 'red' } }, ' *' ),
				el( 'input', { type: 'text', name: 'form-blocks[contact-form][name]' } )
			),

			// FIELD: Email Address
			el( 'div', { className: 'form-blocks--field-wrap' },
				el( 'label', { style: { display: 'inline-block' } },
					el( Editable, { value: emailLabel, onChange: onChangeEmailLabel } )
				),
				!! showRequired && el( 'span', { style: { color: 'red' } }, ' *' ),
				el( 'input', { type: 'email', name: 'form-blocks[contact-form][email]' } )
			),

			// FIELD: Message
			el( 'div', { className: 'form-blocks--field-wrap' },
				el( 'label', { style: { display: 'inline-block' } },
					el( Editable, { value: messageLabel, onChange: onChangeMessageLabel } )
				),
				!! showRequired && el( 'span', { style: { color: 'red' } }, ' *' ),
				el( 'textarea', { name: 'form-blocks[contact-form][message]' } )
			),

			// FIELD: Submit
			el( 'div', { className: 'form-blocks--field-wrap' },
				/*
				 * For easier contend editable text use a styled 'a' anchor tag, instead of a 'button'.
				 */
				el( 'a', { className: 'button' },
					el( Editable, { tagName: 'span', value: submitLabel, onChange: onChangeSubmitLabel } )
				)
			)
		);
	}

	blocks.registerBlockType( 'form-blocks/contact-form', {
		title: __( 'Contact Form', 'form-blocks' ),
		icon: 'feedback',
		category: 'common',

		attributes: {

			/* Block Controls */
			align: {
				type: 'string',
				default: 'center',
			},
			showRequired: {
				type: 'boolean',
				default: false,
			},

			/* Inspector Controls */
			successMessage: {
				type: 'string',
				default: __( 'Your message has been sent!', 'form-blocks' )
			},
			// storeSubmission: {
			// 	type: 'boolean',
			// 	default: false,
			// },

			/* Field Labels */
			nameLabel: {
				type: 'string',
				default: __( 'Full Name', 'form-blocks' )
			},
			emailLabel: {
				type: 'string',
				default: __( 'Email', 'form-blocks' )
			},
			messageLabel: {
				type: 'string',
				default: __( 'Message', 'form-blocks' )
			},
			submitLabel: {
				type: 'string',
				default: __( 'Submit', 'form-blocks' )
			}
		},

		edit: function( props ) {
			var storeSubmission = props.attributes.storeSubmission,
				successMessage = props.attributes.successMessage,
				sendNotification = props.attributes.sendNotification,
				align = props.attributes.align,
				showRequired = props.attributes.showRequired,
				focus = props.focus;

			function onChangeAlign( newAlign ){
				if( ! newAlign ) return;
				props.setAttributes( { align: newAlign } );
			}
			function toggleShowRequiredControl() {
				props.setAttributes( { showRequired: ! showRequired } );
			}
			function toggleSendNotification() {
				props.setAttributes( { sendNotification: ! sendNotification } );
			}
			function onChangeSuccessMessage( newSuccessMessage ) {
				props.setAttributes( { successMessage: newSuccessMessage } );
			}
			// function toggleStoreSubmission() {
			// 	props.setAttributes( { storeSubmission: ! storeSubmission } );
			// }

			var adminEmailHelp = el( ExternalLink, { href: formBlocks.generalSettings }, __( 'Admin email is set in General Options.', 'form-blocks' ) );

			var inspectorControls = el( InspectorControls, {},
				el( BlockDescription, {}, __( 'Contact Form Settings', 'form-blocks') ),
				el( TextControl, { label: __( 'Success Message', 'form-blocks' ), value: successMessage, onChange: onChangeSuccessMessage } ),
				el( TextControl, { label: __( 'Notification Email', 'form-blocks' ), value: formBlocks.adminEmail, disabled: 'disabled', help: adminEmailHelp } ),
				// el( ToggleControl, { label: __( 'Send Notification', 'form-blocks' ), checked: sendNotification, onChange: toggleSendNotification } ),
				el( BlockDescription, {}, '' ) // Using an empty description as a divider.
				// el( ToggleControl, { label: __( 'Store Submissions', 'form-blocks' ), checked: storeSubmission, onChange: toggleStoreSubmission } ),
			);

			var customControls = [
				{
					title: __( 'Show Required', 'form-blocks' ),
					isActive: showRequired,
					onClick: toggleShowRequiredControl,
					icon: showRequired ? 'star-filled' : 'star-empty',
				}
			];

			return [
				!! focus && el( BlockControls, { key: 'controls', controls: customControls },
					el( AlignmentToolbar, { value: align, onChange: onChangeAlign } )
				),
				!! focus && inspectorControls,
				contactForm( props )
			];
		},
		save: function( props ) {
			var align = props.attributes.align,
				showRequired = props.attributes.showRequired,
				// storeSubmission = props.attributes.storeSubmission,
				sendNotification = props.attributes.sendNotification,
				successMessage = escape( props.attributes.successMessage ),
				nameLabel = escape( props.attributes.nameLabel ),
				emailLabel = escape( props.attributes.emailLabel ),
				messageLabel = escape( props.attributes.messageLabel ),
				submitLabel = escape( props.attributes.submitLabel );

			return '[form_blocks_contact_form ' +
				'align="'+align+'" ' +
				'show_required="'+showRequired+'" ' +
				// 'store="'+storeSubmission+'" ' +
				'success_message="'+successMessage+'" ' +
				'name_label="'+nameLabel+'" ' +
				'email_label="'+emailLabel+'" ' +
				'message_label="'+messageLabel+'" ' +
				'submit_label="'+submitLabel+'" ' +
				']';
		},
	} );
} )(
	window.wp.blocks,
	window.wp.i18n,
	window.wp.element,
	window.wp.components
);
